import { SVGProps } from "react";

const Smile = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="12"
      cy="12"
      r="10"
      stroke="#626262"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8 15C8.91212 16.2144 10.3643 17 12 17C13.6357 17 15.0879 16.2144 16 15"
      stroke="#626262"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
      strokeWidth="0.1"
    />
    <path
      d="M8.00897 9L8 9M16 9L15.991 9"
      stroke="#626262"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export default Smile;
